import React from 'react';
import {MCButton} from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import {
    remCss,
    lang,
    withRouter,
} from 'src/helpers';

import model from './model';
import TextAreaField from "../../../../components/basic/TextAreaField";

class AiSettings extends BaseComponent {
    componentDidMount() {
        model.subscribe(this.subscription);
        if (!model.initFlag) {
            model.refresh();
            model.initFlag = true;
        }
    }

    componentWillUnmount() {
        model.unsubscribe(this.subscription);
        model.initFlag = false;
    }

    save = () => {
        console.log('save');
        // let endDate = model.input('endDate').clone();
        // let newStartDate = endDate.startOf('isoWeek');
        // let newEndDate = newStartDate.clone().add(1, 'week');
        // model.setState({startDate: newStartDate, endDate: newEndDate});
        // model.refresh();
    };

    render() {
        return (
          <div className={'mc-container-content mc-money-statistics'}>
            <div className={'mc-container-content__header'}>
              <span className={'mc-grow'}>{lang.t('AI Settings')}</span>
            </div>
            <div className={'mc-container-content__body'}>
              <div
                className={'mc-container-content__body-content'}
                style={{ marginTop: remCss(25) }}
              >
                <div>Admin Prompt:</div>
                <div>
                  <TextAreaField
                    template={5}
                    name='prompt'
                    placeholder='Enter your AI prompt'
                    value={model.input('prompt')}
                    onChange={(n, v) => {
                      console.log('handle change');
                      model.resetApiState(this.apiStateId);
                      model.handleChange(n, v);
                    }}
                    onBlur={model.handleBlur}
                    invalid={{}}
                    rows={10}
                    resize='none'
                  />
                </div>
                <div style={{ marginTop: remCss(20) }}>
                  <MCButton
                    label={'Save'}
                    // small
                    radius
                    primary
                    dark
                    onClick={this.save}
                  />
                </div>
              </div>
            </div>
          </div>
        );
    }
}

export default withRouter(AiSettings);
